const baseRoute = "/auth"

export const authRoutes = {
    LANDING: `/landing`,
    LOGIN: `${baseRoute}/login`,
    SIGNUP:  `${baseRoute}/signup`,
    GOOGLE_OAUTH:  `${baseRoute}/google/callback`,
    VERIFY_ACCOUNT:  `${baseRoute}/account-verify`,
    RESET_PASSWORD: `${baseRoute}/reset-password`,
    FORGOT_PASSWORD: `${baseRoute}/forgot-password`,
}